module.exports = __webpack_public_path__ + "img/福利商城-产品图.3e41f511.png";